{
  "onboarding": {
    "skip": "OMITIR",
    "next": "SIGUIENTE →",
    "start": "❤️ EMPEZAR",
    "welcome": {
      "title": "Bienvenido\nal Agápe Fund",
      "subtitle": "Promociona la plataforma, gana Corazones Agápe y apoya a tus maestros favoritos con donaciones reales."
    },
    "earn": {
      "title": "Cómo ganar\nCorazones",
      "subtitle": "Corre la voz — cada compartir, invitación y comentario gana corazones:",
      "share": "Compartir contenido",
      "invite": "Invitar a un amigo",
      "subscribe": "Amigo se suscribe",
      "comment": "Comentar una publicación",
      "review": "Dejar una reseña"
    },
    "convert": {
      "title": "Convertir en\nDonaciones",
      "subtitle": "Tus corazones se convierten en dinero real para los maestros.",
      "hearts100": "100 corazones",
      "source": "Fuente del fondo",
      "sourceVal": "10% de suscripciones",
      "minDonation": "Donación mínima",
      "maxMonth": "Máx. por mes"
    },
    "circle": {
      "title": "Crea tu\nCírculo",
      "subtitle": "Para crear tu propio círculo comunitario, necesitas:",
      "subscription": "Suscripción activa",
      "subscriptionVal": "Requerido",
      "hearts": "Corazones mínimos",
      "approvals": "Aprobaciones de amigos",
      "approvalsVal": "10 amigos"
    }
  }
}
